module.exports = __webpack_public_path__ + "static/img/background.ab7bcc18.svg";